if (!customElements.get("tabs-container")) {
  customElements.define(
    "tabs-container",
    class TabsContainer extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      updatedCallback() {
          this.init();
      }

      init() {
        this.buildNav();

        this.screens = this.querySelectorAll(".tabs-container__screen");
        this.buttons = this.querySelectorAll(".tabs-container__button");

        this.buttons.forEach((btn) => {
          const fresh = btn.cloneNode(true);
          btn.replaceWith(fresh);
          fresh.addEventListener("click", () => this.handleAction(fresh));
        });

        this.buttons = this.querySelectorAll(".tabs-container__button");
      }

      buildNav() {
          const nav = this.querySelector(".tabs-container__nav");
          if (!nav) return;
          
          nav.innerHTML = "";

        this.querySelectorAll(".tab-item").forEach((item, i) => {
          if (window.getComputedStyle(item).display === "none") return;

          const tpl = item.querySelector(".tab-button-tpl");
          if (!tpl) return;

          const btn = tpl.content.firstElementChild.cloneNode(true);
          if (i === 0) btn.classList.add("active");
          nav.appendChild(btn);

          const panel = item.querySelector(".tabs-container__screen");
          if (i === 0) panel.classList.add("active");
          else panel.classList.remove("active");
        });
      }

      handleAction(btn) {
        if (!btn.dataset.target) return;
        const target = this.querySelector(`#${btn.dataset.target}`);
        if (!target) return;

        this.buttons.forEach((button) => button.classList.remove("active"));
        btn.classList.add("active");

        this.screens.forEach((screen) => screen.classList.remove("active"));
        target.classList.add("active");
      }
    }
  );
}